<div class="af-tool">
  <!-- Header -->
  <div class="header">
    <button class="back" (click)="onBack()" type="button">
      <iris-icon name="arrow_back" [size]="iconSizes.MD"></iris-icon>
    </button>
    <h3 class="title">Amplitude Feature Flags</h3>
  </div>

  <!-- User context -->
  <div class="user-context">
    <iris-icon name="person" [size]="iconSizes.SM" colorToken="$color-neutral-60"></iris-icon>
    <span class="user-label">
      {{ service.userContext().type === 'authenticated' ? 'User' : 'Anonymous' }}:
      <code>{{ service.userContext().id }}</code>
    </span>
  </div>

  <!-- Note about flag filtering -->
  <div class="note">
    <iris-icon name="info" [size]="iconSizes.SM" colorToken="$color-dec-yellow-100"></iris-icon>
    <span>NOTE: Tool under construction. Only works for flags with a singular "on" variant, and are also tied to both the sonder-client and sonder-rails deployments in Amplitude.</span>
  </div>

  <!-- Search -->
  <div class="toolbar">
    <input
      type="text"
      class="search"
      placeholder="Search flags..."
      (input)="onSearchInput($event)"
      [value]="searchQuery()"
    />
  </div>

  <!-- Flag list -->
  <div class="body">
    @if (service.loading()) {
      <div class="loading">Loading flags...</div>
    } @else if (service.error()) {
      <div class="error">{{ service.error() }}</div>
    } @else if (filteredFlags().length === 0) {
      <div class="empty">No flags found</div>
    } @else {
      @for (flag of filteredFlags(); track flag.key) {
        <div class="af-flag-row">
          <div class="info">
            <span class="key">{{ flag.key }}</span>
          </div>
          <button
            class="toggle"
            [class.on]="flag.currentVariant === 'on'"
            (click)="onToggle(flag.key)"
            type="button"
          >
            {{ flag.currentVariant === 'on' ? 'ON' : 'OFF' }}
          </button>
        </div>
      }
    }
  </div>

  <!-- Footer -->
  <div class="footer">
    <button
      class="clear-all"
      (click)="onClearAll()"
      type="button"
    >
      Clear All (Remove from 'on' Lists)
    </button>
  </div>
</div>
